import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ContentSection,
  InstructionStepper,
  Layout,
  Paragraph,
  SectionHeading,
} from '@vwfs-bronson/bronson-react';
import { useNavigate } from '../../services/routing/navigate';

interface Props {
  formData?: any;
}

export const IdentSuccessForPAPage: FunctionComponent<Props> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      {/* <ContentSection pageWrap>
        <ShoppingCart formData={formData} dataTheme="default" />
      </ContentSection> */}
      <ContentSection pageWrapSize="small">
        <SectionHeading level={3}>{t('identSuccessPage:title')}</SectionHeading>
        <Layout center>
          <Layout.Item>
            <Paragraph>{t('identSuccessPage:subtitle')}</Paragraph>
          </Layout.Item>
        </Layout>
      </ContentSection>
      <ContentSection pageWrap pageWrapSize="medium">
        <InstructionStepper
          statusActiveText={t('app:instructionStepper:activeLabel')}
          statusNotActiveText={t('app:instructionStepper:nonActiveLabel')}
        >
          <InstructionStepper.Step icon="document" title={t('identSuccessPage:instructions:upload')} />
          <InstructionStepper.Step
            icon="checkmark"
            state="is-active"
            title={t('identSuccessPage:instructions:analysis')}
          />
          <InstructionStepper.Step icon="pen" title={t('identSuccessPage:instructions:sign')} />
          <InstructionStepper.Step icon="semantic-calendar" title={t('identSuccessPage:instructions:vehicle')} />
        </InstructionStepper>
      </ContentSection>
      <ContentSection>
        <Layout center>
          <Layout.Item default="1/3">
            <Button type="button" full onClick={() => navigate.form('/5')}>
              {t('identSuccessPage:next')}
            </Button>
          </Layout.Item>
        </Layout>
      </ContentSection>
    </>
  );
};
